module.exports = __webpack_public_path__ + "static/media/status_3.e88b58be.svg";